import { QUERY_KEY, MUTATION_KEY } from "constants/globalConstants";
import CrudApiService from "apiService/crudApiService";
import { useMutation, useQueryClient, useQuery } from "react-query";
import toast from "react-hot-toast";

const useMasterConfigList = () => {
  return useQuery(
    QUERY_KEY.GET_MASTER_CONFIG_LIST,
    () => CrudApiService.getMasterConfigList(),
    { retry: false }
  );
};

const useCreateMasterConfig = (setShowAddForm) => {
  const queryClient = useQueryClient();
  return useMutation(
    [MUTATION_KEY.CREATE_MASTER_CONFIG],
    (data) => CrudApiService.createMasterConfig(data),
    {
      onSuccess: (data) => {
        queryClient.invalidateQueries(QUERY_KEY.GET_MASTER_CONFIG_LIST);
        setShowAddForm(false);
        toast.success("Config created successfully");
        localStorage.setItem(data?.data?.key, data?.data?.default_value);
        window.location.reload();
      },
      onError: (error) => {
        toast.error(error.response.data.message);
      },
    }
  );
};

const useDeleteMasterConfig = (onClose) => {
  const queryClient = useQueryClient();
  return useMutation(
    [MUTATION_KEY.DELETE_MASTER_CONFIG],
    (id) => CrudApiService.deleteMasterConfig(id),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(QUERY_KEY.GET_MASTER_CONFIG_LIST);
        onClose();
        toast.success("Config deleted successfully");
        window.location.reload();
      },
      onError: (error) => {
        toast.error(error.response.data.message);
      },
    }
  );
};

const useUpdateMasterConfig = (setShowEditForm) => {
  const queryClient = useQueryClient();
  return useMutation(
    [MUTATION_KEY.UPDATE_MASTER_CONFIG],
    (data) => CrudApiService.editMasterConfig(data),
    {
      onSuccess: (data) => {
        queryClient.invalidateQueries(QUERY_KEY.GET_MASTER_CONFIG_LIST);
        setShowEditForm(false);
        toast.success("Config updated successfully");
        localStorage.setItem(data?.data?.key, data?.data?.default_value);
        document.title = data?.data?.default_value || "NDMS";
        window.location.reload();
      },
      onError: (error) => {
        toast.error(error.response.data.message);
      },
    }
  );
};

const MasterConfigHooks = {
  useMasterConfigList,
  useCreateMasterConfig,
  useDeleteMasterConfig,
  useUpdateMasterConfig,
};

export default MasterConfigHooks;
